<template>
  <div>
    <!-- report header -->
    <div class="w-full">
      <el-card
        class="box-card header-report bg-blue-600 text-white bg-gradient-to-r from-blue-600 to-blue-200 px-4"
        :class="!printable ? 'py-4' : ''"
      >
        <div
          class="w-full flex flex-col space-y-2 lg:space-y-0 lg:text-right lg:flex lg:flex-row lg:justify-between lg:justify-items-center"
        >
          <slot name="header"></slot>
          <div class="flex justify-start lg:justify-between">
            <img
              src="/images/TMONE_logo.png"
              alt="TMONE logo"
              class="h-12 -mt-5"
            />
            <div class="flex justify-between h-14 -mt-5" v-if="customerLogo">
              <div
                class="divider border-r border-blue-600"
                style="height: 35px; margin: auto 10px;"
              ></div>
              <img
                :src="customerLogo"
                :alt="`${form.customer} logo`"
                class="h-10 mt-2"
              />
            </div>
          </div>
        </div>
        <div class="w-full lg:flex lg:justify-items-center lg:justify-end">
          <slot name="sub-header" class="w-full"></slot>

          <div class="flex cursor-pointer text-lg mt-10">
            <el-dropdown @command="downloadReport" trigger="click">
              <div
                class="rounded-full h-10 w-10 bg-blue-600 flex items-center justify-center text-white hover:opacity-75"
              >
                <app-icon
                  name="download"
                  style="height: 2em; stroke: #fff; fill: none;"
                  fill
                ></app-icon>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="'pdf'">PDF</el-dropdown-item>
                <el-dropdown-item :command="'excel'">Excel</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div
              class="ml-2 rounded-full h-10 w-10 bg-blue-600 flex items-center justify-center text-white hover:opacity-75"
              @click="popupSendMail(true)"
            >
              <app-icon
                name="email"
                style="height: 2em; stroke: #fff; fill: none;"
                fill
              ></app-icon>
            </div>
            <div
              class="ml-2 rounded-full h-10 w-10 bg-blue-600 flex items-center justify-center text-white hover:opacity-75"
              @click="printReport()"
            >
              <app-icon
                name="print"
                style="height: 2em; stroke: #fff; fill: none;"
                fill
              ></app-icon>
            </div>
          </div>
        </div>
      </el-card>

      <PopupSendMail
        :reportForm="form"
        :popup-open="popupOpen"
        :pdf-source="pdfSource"
        @closePopup="popupSendMail(false)"
      />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import config from '@/config.json'
import base64logo from '@/assets/images/base64logo.json'
// import AppIcon from '@/components/AppIcon'
import PopupSendMail from '@/components/Popup/SendMail'

export default {
  components: {
    // AppIcon,

    AppIcon: () => import('@/components/AppIcon'),
    PopupSendMail
  },
  props: {
    printable: {
      type: Boolean,
      default: () => false
    },
    form: {
      type: Object,
      default: () => {}
    },
    customerLogo: {
      type: String,
      default: () => ''
    },
    pdfSource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tmLogo: base64logo.tm,
      popupOpen: false
    }
  },
  methods: {
    downloadReport(type) {
      if (type == 'pdf') {
        this.$emit('downloadPdf', true)
        this.$emit('downloadExcel', false)
      } else if (type == 'excel') {
        this.$emit('downloadPdf', false)
        this.$emit('downloadExcel', true)
      }
    },
    printReport() {
      this.$emit('printReport', true)
    },
    popupSendMail(val) {
      this.popupOpen = val
    }
  }
}
</script>
